
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-tutor",
      function () {
        return require("private-next-pages/become-a-tutor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-tutor"])
      });
    }
  